module.exports = __webpack_public_path__ + "img/ear.e9600813.svg";